import { connect } from 'react-redux';

import LoginModal, {
  LoginModalDispatchProps,
  LoginModalStateProps,
} from '../components/LoginModal';
import { login } from '../actionCreators';
import { StoreState } from '../reducers';

const mapStateToProps = ({ auth }: StoreState): LoginModalStateProps => ({
  error: auth.error,
  loading: auth.loading,
});

const mapDispatchToProps: LoginModalDispatchProps = {
  login,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);
